import home_page_img from '@/public/images/course-preview-image.png'
import { Container } from '@/components/pages/course-landing/Container'
import { BlackSectionTwo } from '@/components/pages/course-landing/BlackSectionTwo'
import Head from 'next/head'
import { Header } from '@/components/pages/course-landing/Header'
import { FooterSec } from '@/components/pages/course-landing/FooterSec'
import Link from 'next/link'
import { imageLoader } from '@/loaders/index'
import { Headline } from '@/components/pages/course-landing/Headline'
import { Trustpilot } from '@/components/pages/course-landing/Trustpilot'
import { Button } from '@/components/controls/Button'
import Image from 'next/image'
import { HeroSection } from '@/components/pages/course-landing/HeroSection'
import { BlackSection } from '@/components/pages/course-landing/BlackSection'
import { CoachSection } from '@/components/pages/course-landing/CoachSection'
import { LearnSection } from '@/components/pages/course-landing/LearnSection'
import { Testimonial } from '@/components/pages/course-landing/Testimonial'
import { FaqSection } from '@/components/pages/course-landing/FaqSection'
import { CTA } from '@/components/pages/course-landing/CTA'
import { Column, Grid } from '@/components/pages/course-landing/Grid'

import testim_ava from '@/public/images/testim_ava1.jpg'
import tino_ava from '@/public/images/tino_ava.png'
import danielle_ava from '@/public/images/danielle_ava.jpg'
import avatars from '@/public/images/avatars.png'
import { Arrow } from '@/components/pages/course-landing/Arrow'
import { useQuery } from '@/utils/url'

import { useEffect } from 'react'
import { useSelector } from 'react-redux'

export const CourseLandingLight = () => {
  const checkoutLink = useQuery('/checkout', { type: 'productivity-course' })
  const checkoutState = useSelector((state) => state.checkout)

  const renderCouponTopBar = () => {
    if (checkoutState.coupon.value === 'BF2024') {
      return (
        <div className={'banner flex items-center justify-center w-full'}>
          <Link href={checkoutLink} passHref>
            <a className='flex w-full h-full justify-center'>
              <span className="mr-[10px] lg:mr-[30px] flex items-center text-left font-extralight leading-4">
                <span><b className='text-[10px] md:text-[14px] mr-[10px] ml-[10px]'>🔥 <b className='font-bold'>BLACK FRIDAY DEAL APPLIED:</b>  WAS ${checkoutState.coupon.initialPrice} NOW ${checkoutState.coupon.finalPrice} <span className='underline'>(SAVE ${checkoutState.coupon.discount}!)</span> 🔥</b></span>
              </span>
            </a>
          </Link>
        </div>
      )
    } else if (
      checkoutState.coupon.available &&
      checkoutState.coupon.initialPrice &&
      checkoutState.coupon.finalPrice &&
      checkoutState.coupon.discount
    ) {
      return (
        <div className={'banner flex items-center justify-center w-full'}>
          <Link href={checkoutLink} passHref>
            <a className='flex w-full h-full justify-center'>
              <span className="mr-[10px] lg:mr-[30px] flex items-center text-left font-extralight leading-4">
                <span><b className='text-[10px] md:text-[14px] mr-[10px] ml-[10px]'>🔥 <b className='font-bold'>Special Discount Activated!</b>  Was ${checkoutState.coupon.initialPrice} Now ${checkoutState.coupon.finalPrice} <span className='underline'>(Save ${checkoutState.coupon.discount}!)</span> 🔥</b></span>
              </span>
            </a>
          </Link>
        </div>
      )
    }
  }

  useEffect(() => {
    const script = document.getElementById('wistia_script')

    if (!script) {
      const wistiaScript = document.createElement('script')
      wistiaScript.id = 'wistia_script'
      wistiaScript.type = 'text/javascript'
      wistiaScript.src = 'https://fast.wistia.com/assets/external/E-v1.js'
      wistiaScript.async = true
      document.body.appendChild(wistiaScript)
    }
  }, [])

  return (
    <>
      <Head>
        <title>Scientific Productivity Course | Commit Action</title>
        <meta name="description" content="The complete evidence-based course on smart planning & effortless execution for entrepreneurs who want to move fast and lead with clarity." />
        <link rel="canonical" href={process.env.NEXT_PUBLIC_SITE} />
        <meta property="og:url" content={`${process.env.NEXT_PUBLIC_SITE}`} />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Scientific Productivity Course | Commit Action" />
        <meta property="og:description" content="The complete evidence-based course on smart planning & effortless execution for entrepreneurs who want to move fast and lead with clarity." />
        <meta property="og:image" content={`${process.env.NEXT_PUBLIC_SITE}${home_page_img.src}`} />
        <meta name="twitter:title" content="Scientific Productivity Course | Commit Action" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:description" content="The complete evidence-based course on smart planning & effortless execution for entrepreneurs who want to move fast and lead with clarity."/>
        <meta name="twitter:image" content={`${process.env.NEXT_PUBLIC_SITE}${home_page_img.src}`} />
      </Head>
      {renderCouponTopBar()}
      <div className='bg--white color--black relative overflow-hidden font--accent'>
        <Container withPattern={true}>
          <Header hideMenu>
            <div className="flex items-center">
              <Link href={'#whats-inside'} passHref><a className="ml-[30px]">What’s Inside?</a></Link>
              <Link href={'#whos-this-for'} passHref><a className="ml-[30px]">Who’s This For?</a></Link>
              <Link href={'#your-tutor'} passHref><a className="ml-[30px]">Your Tutor</a></Link>
              <Link href={'#testimonials'} passHref><a className="ml-[30px]">Testimonials</a></Link>
              <Link href={'#faq'} passHref><a className="ml-[30px]">FAQ</a></Link>
            </div>
          </Header>
          <HeroSection className='pt-[130px] md:pt-[200px] pb-[90px] md:pb-[160px]'/>
        </Container>
        <main>
          <BlackSection></BlackSection>
          <LearnSection></LearnSection>
          <section>
            <Container withPattern>
              <Grid className='pt-[90px] md:pt-[170px] pb-[60px] flex-col md:flex-row'>
                <Testimonial
                  className='md:w-[27%] md:mr-[14px] mb-[30px] md:mb-0'
                  name="Skye K"
                  company='Founder | Profit Partnerships Gr.'
                  photo={testim_ava}
                  text='“In the 3 months I’ve been with Commit Action my revenue has increased by 50% and I’ve hired a team to help me execute which has bought my total hours worked down to 25 per week (while growing 2 companies)”'
                />
                <Testimonial
                  className='md:w-[40%] md:mr-[14px] mb-[30px] md:mb-0'
                  name="Tino T."
                  company='Founder | Measured Growth'
                  photo={tino_ava}
                  text='“Commit Action has been game changing for my business. I went from feeling overwhelmed and scattered with to-dos to having clarity on my yearly goals, milestones to hit, and daily tasks that would get me there. I’ve gotten so much more done than I would have on my own and reaching”'
                />
                <Testimonial
                  className='md:w-[33%]'
                  name="Danielle Dirks, Ph.D."
                  company='Founder | December December'
                  photo={danielle_ava}
                  text='“Commit Action, and my coach in particular, Brittany, have been nothing short of life changing this past year of working with them. So many of my peers ask how I’m managing to get so much done and at scale, and I always point them back to having...'
                />
              </Grid>
              <Grid className='pb-[90px] md:pb-[160px] flex-col md:flex-row'>
                <Column className='md:w-[20%] order-2 md:order-1'>
                  <div className='text-center md:text-left flex flex-col items-center md:items-start mb-[30px] md:mb-0'>
                    <Headline tag='h5' className='text-[15px] mb-[12px] leading-[1]'>Join 8000+ Entrepreneurs</Headline>
                    <div className='w-[225px] md:w-[185px]'>
                      <Image
                        src={avatars}
                        priority
                        alt="customers photos"
                        loader={imageLoader}
                      />
                    </div>
                  </div>
                </Column>
                <Column className='order-3 md:order-2'>
                  <div className='justify-center'>
                    <Trustpilot numberOfReviews={process.env.NEXT_PUBLIC_TRUSTPILOT_REVIEWS_COUNT} rating={4.6}/>
                  </div>
                </Column>
                <Column className='md:ml-auto order-1 md:order-3 mb-[30px]'>
                  {checkoutState.coupon.available && checkoutState.coupon.finalPrice && checkoutState.coupon.initialPrice &&
                    <Button href={checkoutLink} radius={0} size="large" className="w-full md:w-[340px] px-[40px] py-[15px]" uppercase={false}><span className="text-[18px]">Get Instant Access <span className='line-through'>${checkoutState.coupon.initialPrice}</span> ${checkoutState.coupon.finalPrice}</span><Arrow className="ml-[16px] rotate-[-45deg]"/></Button>
                  }
                  {!checkoutState.coupon.available &&
                    <Button href={checkoutLink} radius={0} size="large" className="w-full md:w-[340px] px-[40px] py-[15px]" uppercase={false}><span className="text-[18px]">Get Instant Access $97</span></Button>
                  }
                </Column>
              </Grid>
            </Container>
          </section>
          <BlackSectionTwo/>
          <CoachSection/>
          <CTA/>
          <section id="testimonials">
            <Container withPattern>
              <Grid className='pt-[90px] md:pt-[170px] pb-[60px] flex-col md:flex-row'>
                <Testimonial
                  className='md:w-[27%] md:mr-[14px] mb-[30px] md:mb-0'
                  name="Skye K"
                  company='Founder | Profit Partnerships Gr.'
                  photo={testim_ava}
                  text='“In the 3 months I’ve been with Commit Action my revenue has increased by 50% and I’ve hired a team to help me execute which has bought my total hours worked down to 25 per week (while growing 2 companies)”'
                />
                <Testimonial
                  className='md:w-[40%] md:mr-[14px] mb-[30px] md:mb-0'
                  name="Tino T."
                  company='Founder | Measured Growth'
                  photo={tino_ava}
                  text='“Commit Action has been game changing for my business. I went from feeling overwhelmed and scattered with to-dos to having clarity on my yearly goals, milestones to hit, and daily tasks that would get me there. I’ve gotten so much more done than I would have on my own and reaching”'
                />
                <Testimonial
                  className='md:w-[33%]'
                  name="Danielle Dirks, Ph.D."
                  company='Founder | December December'
                  photo={danielle_ava}
                  text='“Commit Action, and my coach in particular, Brittany, have been nothing short of life changing this past year of working with them. So many of my peers ask how I’m managing to get so much done and at scale, and I always point them back to having...'
                />
              </Grid>
              <Grid className='pb-[90px] md:pb-[160px] flex-col md:flex-row'>
                <Column className='md:w-[20%] order-2 md:order-1'>
                  <div className='text-center md:text-left flex flex-col items-center md:items-start mb-[30px] md:mb-0'>
                    <Headline tag='h5' className='text-[15px] mb-[12px] leading-[1]'>Join 8000+ Entrepreneurs</Headline>
                    <div className='w-[225px] md:w-[185px]'>
                      <Image
                        src={avatars}
                        priority
                        alt="customers photos"
                        loader={imageLoader}
                      />
                    </div>
                  </div>
                </Column>
                <Column className='order-3 md:order-2'>
                  <div className='justify-center'>
                    <Trustpilot numberOfReviews={process.env.NEXT_PUBLIC_TRUSTPILOT_REVIEWS_COUNT} rating={4.6}/>
                  </div>
                </Column>
                <Column className='md:ml-auto order-1 md:order-3 mb-[30px]'>
                  {checkoutState.coupon.available && checkoutState.coupon.finalPrice && checkoutState.coupon.initialPrice &&
                    <Button href={checkoutLink} radius={0} size="large" className="w-full md:w-[340px] px-[40px] py-[15px]" uppercase={false}><span className="text-[18px]">Get Instant Access <span className='line-through'>${checkoutState.coupon.initialPrice}</span> ${checkoutState.coupon.finalPrice}</span><Arrow className="ml-[16px] rotate-[-45deg]"/></Button>
                  }
                  {!checkoutState.coupon.available &&
                    <Button href={checkoutLink} radius={0} size="large" className="w-full md:w-[340px] px-[40px] py-[15px]" uppercase={false}><span className="text-[18px]">Get Instant Access $97</span></Button>
                  }
                </Column>
              </Grid>
            </Container>
          </section>
          <FaqSection/>
        </main>
        <FooterSec/>
      </div>
    </>
  )
}
